import * as React from 'react';
import { makeObservable } from 'mobx';
import { Button } from '@shared/ui-react/Button';
import { cs } from '@shared/utils/utils-classname';
import { observer } from 'mobx-react';
import { ILongSectionLoadSelection, LongSectionStore } from '@pages/cross-section/long-section/LongSectionStore';
import { CrossSectionModelsListComponent } from '@pages/cross-section/shared/CrossSectionModelsListComponent';
import { CrossSectionZoomComponent } from '@pages/cross-section/shared/CrossSectionZoomComponent';
import '../shared/CrossSectionComponent.scss';
import { CrossSectionViewState } from '../shared/CrossSectionWindow';


@observer
export class LongSectionComponent extends React.Component<{
    stationStart?: number;
    stationEnd?: number;
    selection: ILongSectionLoadSelection;
    treeData?: ITreeData;
    view?: CrossSectionViewState;
    searchDisplacement?: number;
}> {
    store = new LongSectionStore(this.props.treeData, this.props.view);

    constructor(props) {
        super(props);
        makeObservable(this);

        if (this.props.stationStart) {
            this.store.settings.stationStart = this.props.stationStart;
        }
        if (this.props.stationEnd) {
            this.store.settings.stationEnd = this.props.stationEnd;
        }
        if (this.props.searchDisplacement) {
            this.store.settings.searchDisplacement = this.props.searchDisplacement;
        }
    }

    render() {
        console.log('render CS ui');

        return (
            <div className={cs('cross-section__window', { 'overlay-loading': this.store.isLoading || this.store.isLoadingTree })}>
                {!!this.store.csCanvas &&
                    <form style={{ flex: 0, gap: 5, flexWrap: 'wrap', display: 'inline-flex', margin: '0 0 10px 10px' }} onSubmit={e => {
                        e.preventDefault();
                        this.store.fetchDrawing(null)}
                    }>

                        <CrossSectionZoomComponent store={this.store}/>

                        <div className="toolbar-group flex-row gap-half" style={{ flexWrap: 'wrap' }}>
                            <div className="flex-row">
                                <label htmlFor="logpointDelta">{__('cross_section.logpoint_search_displacement')}:</label>
                                <input id="logpointDelta" type="number" min={0} step={0.1} autoComplete="off" style={{ width: 80 }}
                                       value={this.store.settings.searchDisplacement} onChange={e => this.store.settings.searchDisplacement = parseFloat(e.target.value) ?? 2}/>
                            </div>

                            <button type="submit" disabled={this.store.isLoading}>{__('general.apply')}</button>
                        </div>

                        <div className="toolbar-group flex-row gap-half" style={{ flexWrap: 'wrap' }}>
                            <Button icon="crosssection-fat" className={this.store.crossSectionToolActive ? 'active' : null} onClick={this.store.toggleCrossSectionTool}/>
                            <Button icon="file" onClick={this.store.createPdf} loading={this.store.isCreatingPdf}>PDF</Button>
                        </div>
                    </form>
                }

                {!this.store.isLoadingTree &&
                    <div className="cross-section__models_canvas_wrapper">
                        <CrossSectionModelsListComponent store={this.store} hasPipes={false} hasLayers={false}/>

                        <div className='cross-section__canvas_wrapper'>
                            <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0 }} ref={el => this.store.setCanvasEl(el, this.props.selection)}></div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}
